import { useSelector } from 'react-redux';
import { useLocalStorage, useSessionStorage } from 'react-use';

import { getUserID } from '@app/store/user/user/selectors';

function getRemainingCountLocalStorageKey(userId: string | null) {
  return `modusign_userEmailConfirmationCount-${userId}`;
}

function getIsCheckedSessionStorageKey(userId: string | null) {
  return `modusign_userEmailConfirmationChecked-${userId}`;
}

/**
 * 카카오 싱크로 비회원 서명 후 회원가입 경로를 따랐을 때 카카오 이메일을 확인받습니다.
 * 이후 유저가 세 번 확인할 때 까지 알림을 띄웁니다.
 * 참고: https://github.com/modusign/modusign-client/pull/7246
 */
export default function useUserEmailConfirmation() {
  const userId = useSelector(getUserID);

  const [remainingCount, setRemainingCount, removeRemainingCount] = useLocalStorage<number>(
    getRemainingCountLocalStorageKey(userId)
  );
  const [isChecked, setIsChecked] = useSessionStorage(getIsCheckedSessionStorageKey(userId), false);

  // 유저가 이번 브라우저 세션에서 확인했을 때는 알림을 띄우지 않습니다.
  const needToCheckEmail = !!remainingCount && !isChecked;

  return {
    needToCheckEmail,
    checkOnce: () => {
      if (!remainingCount) {
        return;
      }

      setIsChecked(true);
      if (remainingCount === 1) {
        removeRemainingCount();
      } else if (remainingCount > 1) {
        setRemainingCount(remainingCount - 1);
      }
    },
    // userId가 redux에 없을 때 호출되기 때문에 userId를 parameter로 받습니다.
    setCount: (count: number, userId: string) => {
      window.localStorage.setItem(getRemainingCountLocalStorageKey(userId), count.toString());
    },
  };
}
